import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import { InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import AppNavbar from "./AppNavbar"

const UserWiseStatistics = () => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");

    useEffect(() => {
        // Check if user is logged in and is admin
        const loginData = localStorage.getItem('login');
        if (loginData) {
            try {
                const user = JSON.parse(loginData);
                if (user.role !== 'admin') {
                    toast.error('Access denied. Admin only.');
                    navigate('/');
                }
            } catch (error) {
                navigate('/login');
            }
        } else {
            navigate('/login');
        }

        // Fetch users for dropdown
        fetchUsers();
        getData();
    }, [navigate]);

    useEffect(() => {
        getData();
    }, [selectedUser]);

    const fetchUsers = async () => {
        try {
            const response = await fetch(
                'https://hospital.rozeetechnist.com/hospital-api/getUsersForDropdown.php',
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            const result = await response.json();
            if (result.status && result.data) {
                setUserOptions(result.data);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleUserChange = (selectedOption) => {
        setSelectedUser(selectedOption || "");
    };

    const getData = () => {
        fetch(`https://hospital.rozeetechnist.com/hospital-api/getUserWiseStatistics.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                user_id: selectedUser && selectedUser.value ? selectedUser.value : ''
            })
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.status) {
                    setList(result.data || []);
                } else {
                    setList([]);
                    if (result.message !== "No data found!") {
                        toast.error(result.message);
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                toast.error('Error fetching statistics');
            });
    };

    return (
        <div>
            <AppNavbar />

            <section className="wrapper">
                <div className="container">
                    <div className="row top-page-bar">
                        <div className="col-md-10">
                            <div className="main-title">
                                <h1>User Wise Statistics</h1>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="search-area">
                                <InputGroup style={{ width: '100%' }}>
                                    <Select
                                        name="user"
                                        onChange={handleUserChange}
                                        options={userOptions}
                                        placeholder="Select User"
                                        isClearable
                                        value={selectedUser}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            })
                                        }}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>

                <main className="container">
                    {list && list.length > 0 ? (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>User Name</th>
                                    <th>Total Amount</th>
                                    <th>Total Collected</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.map((item, index) => (
                                    <tr key={item.user_id || index}>
                                        <td>{item.user_name}</td>
                                        <td>₹ {item.total_amount}</td>
                                        <td>₹ {item.total_collected}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No data found</p>
                    )}
                </main>
            </section>
        </div>
    );
};

export default UserWiseStatistics;
